<template>
  <div class="h-toolbarBg">
    <ejs-toolbar ref="realTaskToolbar">
      <e-items>
        <e-item
          prefixIcon="icon hero-icon hero-icon-add"
          :tooltipText='$t("Pm.establishTask")'
          :click="buttonClick"
          operate="add"
        ></e-item>
        <!-- <e-item type="Separator"></e-item> -->
        <e-item
          prefixIcon="icon hero-icon hero-icon-confirm"
          :tooltipText='$t("Pm.startUp")'
          :click="buttonClick"
          operate="start"
        ></e-item>
        <e-item
          prefixIcon="icon hero-icon hero-icon-disable"
          :tooltipText='$t("Pm.pause")'
          :click="buttonClick"
          operate="stop"
        ></e-item>
        <e-item
          prefixIcon="icon hero-icon hero-icon-remove"
          :tooltipText='$t("Pm.del")'
          :click="buttonClick"
          operate="delete"
        ></e-item>
        <e-item
          prefixIcon="icon hero-icon hero-icon-export"
          :tooltipText='$t("Pm.export")'
          :click="buttonClick"
          operate="export"
        ></e-item>
        <!-- <e-item type="Separator"></e-item> -->
        <e-item
          prefixIcon="icon hero-icon hero-icon-search-membership"
          :tooltipText='$t("Pm.checkUniformity")'
          :click="buttonClick"
          operate="consistency"
        ></e-item>
        <e-item
          prefixIcon="icon hero-icon hero-icon-sync-download"
          :tooltipText='$t("Pm.synchronousDownload")'
          :click="buttonClick"
          operate="sync"
        ></e-item>
        <e-item
          prefixIcon="icon hero-icon hero-icon-task-tracking"
          :tooltipText='$t("Pm.queryDetailInfo")'
          :click="buttonClick"
          operate="detail"
        ></e-item>
        <e-item
          prefixIcon="icon hero-icon hero-icon-check-data-integrity"
          :tooltipText='$t("Pm.queryInfo")'
          :click="buttonClick"
          operate="search"
        ></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ToolBarForTaskList',
  data() {
    return {
      currentUserName: '',
      currentClientIP: '',
      serviceTime:0
    };
  },
  mounted() {
    // 加载时图标都是灰色，后续根据选择的数据变化
    this.$refs.realTaskToolbar.enableItems([0, 1, 2, 3, 4, 5, 6, 7, 8], true);

    // 查询当前用名和IP地址
    //this.getCurrentClientInfo();

    //查询后台时间
    this.getServiceTime();
  },
  methods: {
    buttonClick(args) {
      this.$parent.methodList(args.item.operate);
    },
    setEnableItems(row) {
      // 调试时打开注释
      // return;
      const dataAvailbleTime = this.computeTaskRemoteTimeBeforeDelete(row);
      // 当前用户创建的任务 row.alarmCreatePelope === this.currentUserName
      // 暂屏掉用户名判断
      if (true === true) {
        if (row.sysMeterTimelyStatus === 0) {
          // 暂停
          this.$refs.realTaskToolbar.enableItems([2, 6], false);
          this.$refs.realTaskToolbar.enableItems([1, 3, 4, 5, 7, 8], true);
        } else if (row.sysMeterTimelyStatus === 1) {
          // 启动
          this.$refs.realTaskToolbar.enableItems([1, 3], false);
          this.$refs.realTaskToolbar.enableItems([2, 4, 5, 6, 7, 8], true);
        } else {
          // 失效
          this.$refs.realTaskToolbar.enableItems([1, 2, 5, 6], false);
          this.$refs.realTaskToolbar.enableItems([3, 7], true);
          if (dataAvailbleTime > 0) {
            this.$refs.realTaskToolbar.enableItems([4, 8], true);
          } else {
            this.$refs.realTaskToolbar.enableItems([4, 8], false);
          }
        }
      } else {
        // 非当前用户创建的用户
        if (row.taskTypeTumely === 0) {
          if (row.sysMeterTimelyStatus === 0) {
            this.$refs.realTaskToolbar.enableItems([1, 2, 3, 6], false);
            this.$refs.realTaskToolbar.enableItems([4, 5, 7, 8], true);
          } else if (row.sysMeterTimelyStatus === 1) {
            this.$refs.realTaskToolbar.enableItems([1, 2, 3, 6], false);
            this.$refs.realTaskToolbar.enableItems([4, 5, 7, 8], true);
          } else {
            // 失效
            this.$refs.realTaskToolbar.enableItems([1, 2, 3, 5, 6], false);
            this.$refs.realTaskToolbar.enableItems([7], true);

            if (dataAvailbleTime > 0) {
              this.$refs.realTaskToolbar.enableItems([4, 8], true);
            } else {
              this.$refs.realTaskToolbar.enableItems([4, 8], false);
            }
          }
        } else {
          this.$refs.realTaskToolbar.enableItems(
            [0, 1, 2, 3, 4, 5, 6, 7, 8],
            false
          );
        }
      }
    },
    /**
     * 计算任务被从数据库中删除前剩余的时间
     */
    computeTaskRemoteTimeBeforeDelete(taskRecord) {
      const EIGHT_HOURS_SECONDS = 28800;
      let result = 0;
      // 单位为s
      const taskTimeLength = taskRecord.sysMeterTimelyTimeQuant || 0;
      // 单位为ms
      const nowTime = Math.trunc(this.serviceTime/1000)*1000 || Date.parse(new Date()) || 0;
      // 单位为ms
      const createTaskTime = Date.parse(taskRecord.alarmCreateTime) || 0;

      result = taskTimeLength + EIGHT_HOURS_SECONDS - (nowTime - createTaskTime) / 1000;
      return result;
    },
    // 获取当前客户端的信息
    getCurrentClientInfo() {
      const _this = this;
      this.$axios
        .post('/lte/pm/currenttime/taskmanagement/getCurrentClientInfo.html', {
          systemId: 1
        })
        .then(response => {
          let principal = JSON.parse(sessionStorage.getItem('principal'));
          _this.currentUserName = principal.username;
          _this.currentClientIP = response.data.resultVal.clientIP;
        });
    },
    //得到后台时间
    getServiceTime(){
        const _this = this;
        //请求后台的时间
        this.$axios.get('/lte/pm/currenttime/taskmanagement/getCurrentSystemTime.html', {}).then(response => {
          _this.serviceTime = response.data;
        });
    }
  }
};
</script>

<style>
</style>
